/**
 * API Configuration Utility
 * Determines the correct backend URLs based on the current environment
 * 
 * DATA SOURCES:
 * - Draaidagen: Airtable (created/managed there)
 * - Materialen: Airtable (created/managed there)
 * - Reserveringen: PostgreSQL (faster, no rate limits)
 * - Junctions: PostgreSQL (faster, no rate limits)
 */

// Detect environment and set appropriate URLs
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const isTest = window.location.hostname === 'test.fullframe.nl';

// Geexporteerd voor de TestEnvironmentBanner — test heeft een eigen database met demodata.
export const isTestEnvironment = isTest;

// Staging-omgeving waar het backlog-bord zijn testlinks naartoe wijst. Stond eerder
// als los stringetje in Backlog.jsx, terwijl dezelfde host hierboven al bepaalt wat
// "test" is. Te verleggen via REACT_APP_STAGING_URL zonder de code aan te raken.
export const STAGING_URL = process.env.REACT_APP_STAGING_URL || 'https://test.fullframe.nl';

// Eén server: de engine is de voordeur. Alles gaat daarheen — /api/v1/* wordt
// native afgehandeld, /Api/* is de namespace die van de Node-backend komt.
// Lokaal kan REACT_APP_AI_ENGINE_URL naar de test-engine wijzen (die staat localhost:3000 toe
// in CORS), zodat de frontend zonder eigen engine met testdata draait. Alleen op localhost.
export const AI_ENGINE_URL = isLocalhost
  ? process.env.REACT_APP_AI_ENGINE_URL || 'http://localhost:8000'
  : isTest
    ? 'https://ff-interne-ai-engine-test.bluewater-2c879537.westeurope.azurecontainerapps.io'
    : 'https://ff-interne-ai-engine.bluewater-2c879537.westeurope.azurecontainerapps.io';

export const BACKEND_URL = AI_ENGINE_URL;

export const API_ENDPOINTS = {
  draaidagen: {
    list: () => `${BACKEND_URL}/Api/draaidagen`,
    get: (id) => `${BACKEND_URL}/Api/draaidagen/${id}`,
    update: (id) => `${BACKEND_URL}/Api/draaidagen/${id}`,
  },
  materials: {
    list: () => `${BACKEND_URL}/Api/materialen`,
    get: (id) => `${BACKEND_URL}/Api/materialen/${id}`,
    batch: () => `${BACKEND_URL}/Api/materialen/batch`,
    resolveOldBase: () => `${BACKEND_URL}/Api/materialen/resolve-old-base`,
  },
  reservations: {
    list: () => `${BACKEND_URL}/Api/reservations`,
    get: (id) => `${BACKEND_URL}/Api/reservations/${id}`,
    update: (id) => `${BACKEND_URL}/Api/reservations/${id}`,
    save: () => `${BACKEND_URL}/Api/save-reservation`,
    delete: (id) => `${BACKEND_URL}/Api/reservations/${id}`,
    updateNotitie: (id) => `${BACKEND_URL}/Api/reservations/${id}/notitie`,
    checkAvailability: () => `${BACKEND_URL}/Api/check-availability`,
  },
  junctions: {
    list: () => `${BACKEND_URL}/Api/junctions`,
    create: () => `${BACKEND_URL}/Api/junctions`,
    update: (id) => `${BACKEND_URL}/Api/junctions/${id}`,
    existing: () => `${BACKEND_URL}/Api/junctions/existing`,
  },
  draaidagData: (id) => `${BACKEND_URL}/Api/draaidag-data/${id}`,
};

// Log configuration on load (development only)
if (isLocalhost) {
  console.log('[API Config] Environment: localhost');
  console.log('[API Config] Engine URL:', AI_ENGINE_URL);
}
